import { AllianceFixInter, AllianceInsertInter } from "../interface/interface";

export const AllianceInsertState: AllianceInsertInter = {
  prtn_nm: "",
  prtn_use: "",
  thumbnail: "",
  prtn_info: "",
  prtn_desc: "",
  link: "",
};

export const AllianceFixState: AllianceFixInter = {
  prtn_id: "",
  prtn_nm: "",
  prtn_use: "",
  thumbnail: "",
  prtn_info: "",
  prtn_desc: "",
  link: "",
};
